import { useState, type FormEvent } from 'react'
import { supabase, estConfigure } from '../lib/supabase'
import { LogoComplet } from '../components/Icones'

export function Connexion() {
  const [courriel, setCourriel] = useState('')
  const [motDePasse, setMotDePasse] = useState('')
  const [inscription, setInscription] = useState(false)
  const [nom, setNom] = useState('')
  const [message, setMessage] = useState<string | null>(null)
  const [occupe, setOccupe] = useState(false)

  async function envoyer(e: FormEvent) {
    e.preventDefault()
    setMessage(null)
    setOccupe(true)
    try {
      if (inscription) {
        const { error } = await supabase.auth.signUp({
          email: courriel.trim(),
          password: motDePasse,
          options: {
            data: { nom: nom.trim() },
            // Le lien du courriel de confirmation ramène à l'adresse où l'on
            // s'est inscrit (site en ligne ou localhost pendant les essais).
            emailRedirectTo: window.location.origin
          }
        })
        if (error) throw error
        setMessage(
          'Compte créé. Un administrateur doit maintenant te donner accès à tes chantiers.'
        )
      } else {
        const { error } = await supabase.auth.signInWithPassword({
          email: courriel.trim(),
          password: motDePasse
        })
        if (error) throw error
      }
    } catch (err) {
      setMessage(traduire(err))
    } finally {
      setOccupe(false)
    }
  }

  return (
    <div className="connexion">
      <div className="marque">
        <LogoComplet hauteur={58} />
      </div>

      <h1>Chantiers</h1>
      <p className="intro">
        {inscription
          ? 'Crée ton compte avec ton adresse de travail.'
          : 'Connecte-toi pour accéder à tes chantiers.'}
      </p>

      {!estConfigure && (
        <p className="avis erreur" style={{ marginBottom: 16 }}>
          L'application n'est pas encore reliée à sa base de données. Copie le fichier
          <code> .env.example </code> en <code> .env </code> et renseigne les deux valeurs
          fournies par Supabase.
        </p>
      )}

      <form onSubmit={envoyer}>
        {inscription && (
          <label className="champ">
            <span>Nom complet</span>
            <input
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              autoComplete="name"
              required
            />
          </label>
        )}

        <label className="champ">
          <span>Courriel</span>
          <input
            type="email"
            value={courriel}
            onChange={(e) => setCourriel(e.target.value)}
            autoComplete="email"
            inputMode="email"
            required
          />
        </label>

        <label className="champ">
          <span>Mot de passe</span>
          <input
            type="password"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            autoComplete={inscription ? 'new-password' : 'current-password'}
            minLength={8}
            required
          />
        </label>

        {message && (
          <p className="avis" style={{ marginBottom: 14 }}>
            {message}
          </p>
        )}

        <button className="bouton" disabled={occupe || !estConfigure}>
          {occupe ? 'Un instant…' : inscription ? 'Créer le compte' : 'Se connecter'}
        </button>
      </form>

      <button
        className="bouton creux"
        style={{ marginTop: 10 }}
        onClick={() => {
          setInscription(!inscription)
          setMessage(null)
        }}
      >
        {inscription ? "J'ai déjà un compte" : 'Créer un compte'}
      </button>
    </div>
  )
}

function traduire(err: unknown): string {
  const brut = err instanceof Error ? err.message : String(err)
  if (/Invalid login credentials/i.test(brut)) return 'Courriel ou mot de passe incorrect.'
  if (/already registered/i.test(brut)) return 'Un compte existe déjà avec cette adresse.'
  if (/Password should be/i.test(brut)) return 'Le mot de passe doit faire au moins 8 caractères.'
  if (/Failed to fetch|NetworkError/i.test(brut))
    return 'Aucune connexion. Réessaie une fois le réseau revenu.'
  return brut
}
